import React from "react";
import { Button, Divider, message, theme } from "antd";
import { EditOutlined, CommentOutlined } from "@ant-design/icons";
import { COST_REDESIGN, CREATOR_BASE_URL } from "../../constants";
import { getEditURL } from "../../_helpers/editor";
import {
    createCreationFromTemplate,
    replacePrefillInCreation,
} from "../../utils/templates";
import TokenInButton from "../../finance/TokenInButton";
import DevVariablesPopover from "./DevVariablesPopover";
import log from "cslog";

function CanvasHeaderActions({
    item,
    me,
    isMobile,
    is_internal_user,
    is_template,
    tokenData,
    setOpenTokenModal,
    setCurrentAction,
    reduceToken,
    createCreationMutation,
    updated_prefill,
    setCommentsOpen,
    devs,
    lang,
    active_slug,
    gs_overrides,
    prefill_data,
}) {
    const { token } = theme.useToken();
    return (
        <>
            <DevVariablesPopover
                devs={devs}
                lang={lang}
                item={item}
                active_slug={active_slug}
                gs_overrides={gs_overrides}
                prefill_data={prefill_data}
            />
            <Button
                icon={<CommentOutlined />}
                onClick={() => setCommentsOpen(true)}
            />
            <Divider
                type="vertical"
                style={{ margin: "0 2px", borderColor: token.colorBorder }}
            />
            {is_internal_user && !isMobile && (
                <Button
                    icon={<EditOutlined />}
                    onClick={() =>
                        window.open(
                            `${CREATOR_BASE_URL}template/${item.id}`,
                            "_blank",
                        )
                    }
                >
                    Edit Template
                </Button>
            )}
            <Button
                onClick={() => {
                    if (tokenData[0]?.count < 1) {
                        message.error("You have insufficient token");
                        setOpenTokenModal(true);
                        return;
                    }
                    setCurrentAction({ id: "redesign" });
                    reduceToken.mutate({ amount: 1 });
                }}
            >
                Redesign
                <TokenInButton count={COST_REDESIGN} theme="light" />
            </Button>
            {!isMobile && (
                <Button
                    onClick={() => {
                        const out = createCreationFromTemplate(
                            item,
                            me?.selected_org?.id,
                        );
                        log.d(out, "OUT");
                        const final_out = replacePrefillInCreation(
                            out,
                            updated_prefill,
                        );
                        log.d(final_out, "FINAL OUT");
                        createCreationMutation.mutate({
                            collection: "qp_creation",
                            data: final_out,
                            from_id: item?.id,
                        });
                    }}
                    loading={createCreationMutation.isLoading}
                    icon={<EditOutlined />}
                >
                    Open in Editor
                </Button>
            )}
            {!is_template && (
                <a href={getEditURL(item.id)} target="_blank" rel="noreferrer">
                    <Button>Edit</Button>
                </a>
            )}
        </>
    );
}

export default CanvasHeaderActions;
